import React, { Children, cloneElement, useState, useEffect } from "react"

import PropTypes from "prop-types"
import {
  StyledTabbedForm,
  Nav,
  TabSections,
  TabSection,
  NavItem,
  NavButton,
  NavItemSelected,
  TickIcon,
  Count
} from "./styles"
import {
  CurrentSectionTitle,
  CurrentSectionHighlight,
  CurrentSectionHighlightText,
  CurrentSectionHeading,
  CurrentSectionChevron,
  CurrentSectionHighlightBorder,
  JumpNav,
  JumpNavButton
} from "../../spa-content-nav/styles"
import { faCircleCheck, faChevronDown } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const TabbedForm = ({ children, tabs, selectedTab, onTabClick, disabled }) => {
  const [currentTabKey, setCurrentTabKey] = useState(selectedTab || tabs[0]?.key)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const arrayChildren = Children.toArray(children)

  useEffect(() => {
    if (selectedTab !== undefined && selectedTab !== currentTabKey) {
      setCurrentTabKey(selectedTab)
    }
  }, [selectedTab])

  const currentTab = tabs.find((tab) => tab.key === currentTabKey)

  const handleTabChange = (tab) => {
    setDropdownOpen(false)
    if (tab.onClick) {
      tab.onClick()
    } else if (onTabClick) {
      onTabClick(tab.key)
    } else {
      setCurrentTabKey(tab.key)
    }
  }

  return (
    <StyledTabbedForm>
      <Nav>
        {tabs.map((tab, index) => {
          return (
            <NavItem key={`tab_nav_item_${index}`}>
              <NavButton disabled={disabled} selected={tab.key == currentTabKey} onClick={() => handleTabChange(tab)}>
                {tab.label}

                {tab.success && <TickIcon icon={faCircleCheck} />}
                {!!tab.count && parseInt(tab.count) > 0 && <Count>{tab.count}</Count>}
              </NavButton>
              {tab.key == currentTabKey && <NavItemSelected />}
            </NavItem>
          )
        })}
      </Nav>

      <CurrentSectionTitle style={{ padding: "0" }}>
        <CurrentSectionHighlight>
          <CurrentSectionHighlightText onClick={() => setDropdownOpen(!dropdownOpen)}>
            <CurrentSectionHeading>{currentTab?.label}</CurrentSectionHeading>
            <CurrentSectionChevron direction={dropdownOpen ? "up" : "down"}>
              <FontAwesomeIcon icon={faChevronDown} />
            </CurrentSectionChevron>
          </CurrentSectionHighlightText>
          <CurrentSectionHighlightBorder />
          {dropdownOpen && (
            <JumpNav>
              {tabs.map((tab, index) => (
                <JumpNavButton key={tab.key} onClick={() => handleTabChange(tab)} disabled={disabled}>
                  {tab.label}
                  {tab.success && <TickIcon icon={faCircleCheck} />}
                </JumpNavButton>
              ))}
            </JumpNav>
          )}
        </CurrentSectionHighlight>
      </CurrentSectionTitle>

      <TabSections>
        {arrayChildren.map((child, index) => {
          if (!child.props.tabKey) {
            throw new Error(`TabbedForm child no. ${index + 1} should be passed a 'tabKey' prop`)
          }

          return (
            currentTabKey === child.props.tabKey && (
              <TabSection key={`tab_section_${index}`}>{cloneElement(child)}</TabSection>
            )
          )
        })}
      </TabSections>
    </StyledTabbedForm>
  )
}

TabbedForm.propTypes = {
  children: PropTypes.node
}

export default TabbedForm
